import Home from './Home'
export default Home;



// WEBPACK FOOTER //
// ./src/routes/private/Home/index.js